export const NKY_CONNECT_INSTAGRAM_URL = 'https://www.instagram.com/nkyconnect/';
export const NKY_CONNECT_FACEBOOK_URL =
  'https://www.facebook.com/share/17f8rU4vEy/?mibextid=wwXIfr';
